<template>
  <div>
    <select class="status-select" v-model="data.tow" :disabled="isWorker()">
      <option v-for="tow in options" :key="tow.id" v-bind:value="tow.id">{{ tow.tow }}</option>
    </select>
    <!--<v-select transition="" :options="options" v-model="data.status" :reduce="(option) => option.code" :disabled="data.disabled"></v-select>-->
  </div>
</template>

<script>
//import api from "@/services/api";
import {mapGetters} from "vuex";

export default {
  name: "towColumn",
  props: {
    data: {
      type: Object,
      required: true
    },
    my_props: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      some_val: '2412',
      options: [],
		  myvar: '',
    }
  },

  computed: {
    ...mapGetters(['meRoles', 'Tows'])
  },

  mounted() {
    this.createOptions(this.Tows);
  },

  methods: {
    createOptions(a) {
      this.options = a;
    },

    isWorker() {
      if (this.data.disabled) {
        return true;
      } else {
        return !this.isAvailable(['admin', 'moderator']);
      }

    },
    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    }

  },

  watch: {
    Tows (val) {
      this.createOptions(val);
    },
  }
}
</script>

<style scoped>

</style>
